import { render, staticRenderFns } from "./InsNoticeHome.vue?vue&type=template&id=2f0a221a&scoped=true"
import script from "./InsNoticeHome.vue?vue&type=script&lang=js"
export * from "./InsNoticeHome.vue?vue&type=script&lang=js"
import style0 from "./InsNoticeHome.vue?vue&type=style&index=0&id=2f0a221a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a221a",
  null
  
)

export default component.exports